import script from "./YandexDirectStatProcessor.vue?vue&type=script&setup=true&lang=js"
export * from "./YandexDirectStatProcessor.vue?vue&type=script&setup=true&lang=js"

import "./YandexDirectStatProcessor.vue?vue&type=style&index=0&id=8adfd1a6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8adfd1a6"]])

export default __exports__